<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-skeleton-loader
    :types="types"
    :type="props.type"
    dark
  />
</template>
<script setup lang="ts">
import './styles/loaders.scss';

const props = defineProps({
  type: {
    type: String,
    default: ''
  }
});

const types = {
  label: 'table-cell',
  smallLabel: 'table-cell',
  truckIcon: 'button',
  tag: 'button',
  tagOnRight: 'button',
  deviceActivity: 'button',
  alertIcon: 'avatar',
  devicesListSearchbar: 'chip',
  sortControls: 'button',
  paginationControls: 'button',
  checkbox: 'button',
  expansionButton: 'button',
  expansionButtonWithoutMarginLeft: 'button',
  dataField: 'button'
};
</script>
